import { render, staticRenderFns } from "./MaterialModelsIndex.vue?vue&type=template&id=e90cbd46"
import script from "./MaterialModelsIndex.vue?vue&type=script&lang=js"
export * from "./MaterialModelsIndex.vue?vue&type=script&lang=js"
import style0 from "./MaterialModelsIndex.vue?vue&type=style&index=0&id=e90cbd46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports